import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-coop',
  imports: [],
  templateUrl: './coop.component.html',
  styleUrl: './coop.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoopComponent {

}
